<template>
    <div>
        <template v-if="bill_payment_report === true && bill_categories != null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Bill Payment Report </h1>
            </div>
            <div class="peopple-managment-main">
                <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> Reference/Consumer No. </label>
                                <input name="reference_no" class="form-control" v-model="reference_no" placeholder="Enter reference/consumer number">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> Bill Category </label>
                                <select v-model="bill_category" name="bill_category" class="selectpicker custom-select2"  v-if="bill_categories != null">
                                    <option value="" selected>Select Bill Category</option>
                                    <option v-for="bill_category in bill_categories" v-bind:key="bill_category.categoryName">
                                        {{ bill_category.categoryName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> From Date </label>
                                <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> To Date </label>
                                <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group align-right">
                                <br>
                                <button @click="getBillBatchReport" v-if="!showBtn" class="btn btn-primary">Search</button>
                                <button @click="filterTable" v-if="showBtn" class="btn btn-primary">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
                <div v-show="!hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                    <div class="empty-main pt-0" style="height: 100px">
                        <div class="empty-inner">
                            <img src="/images/new_empty_payments.png" alt="" />
                            <h2> Hi, {{user}}! </h2>
                            <p> Select your requirements and export your desired report </p>
                        </div>
                    </div>
                </div>
                <div v-show="hasPer">
                    <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs" v-if="export_bill_payment_report === true">
                        <div class="field-box export-attendance">
                            <button class="btn btn-primary export" @click="exportReport">Export Report</button>
                        </div>
                    </div>

                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="billPaymentReportTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th style="display: none">ID</th>
                                    <th>Title</th>
                                    <th>Category</th>
                                    <th>Reference No.</th>
                                    <th>Amount</th>
                                    <th>Consumer Title</th>
                                    <th>Trasaction Code</th>
                                    <th>Due Date</th>
                                    <th>Paid Date</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="bill_payment_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="bill_payment_report === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
	var dtTable = null;
    export default {
        data() {
            return {
				reference_no : '',
				bill_category : '',
				from_date : new Date(),
				to_date : new Date(),
				hasPer: false,
				bill_categories : null,
				user : '',
				showBtn: false,
				bill_payment_report: null,
				export_bill_payment_report: null,

            };
        },
        mounted() {
            this.$Progress.start();
			this.can('bill_payment_report|export_bill_payment_report').then(result => {
                this.bill_payment_report = result.bill_payment_report;
                this.export_bill_payment_report = result.export_bill_payment_report;
                this.user = result.user_name;
            }).then(result => {
                if(this.bill_payment_report == true){
        			this.loadFiltersData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
			loadFiltersData: function(){
                this.$Progress.start();
                axios.get('/api/bill_batch_payment_report_data')
					.then(res => {
						if(res.status == 200){
							this.bill_categories = res.data.billCategories;
							this.$Progress.finish();
						}else{
							this.$Progress.fail();
							this.showAlertBox('error','Error to load data');
						}
                    })
                    .then(res=>{
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
					.catch(err => {
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					});
			},
			exportReport: function(){
				this.$Progress.start();
                var formData = {
                    'to_date': moment(this.to_date).format('YYYY-MM-DD'),
					'from_date': moment(this.from_date).format('YYYY-MM-DD'),
					'reference_no': this.reference_no,
					'bill_category': this.bill_category,
                }
                axios.post('/api/bill_batch_payment_export', formData,{
					responseType: 'blob'
				})
				.then(res => {
                    console.log(res);
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'billPaymentReport.xlsx')
					document.body.appendChild(link)
					link.click()
					this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load data');
				});
			},
			filterTable(){
                dtTable.draw();
            },
            getBillBatchReport: function(){
	            this.$Progress.start();
				var that = this;
				dtTable = $('#billPaymentReportTable').DataTable({
					sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
					processing: true,
					serverSide: true,
					ajax: {
						"url": "api/bill_batch_payment_report",
						"data": function (d) {
							d.reference_no = that.reference_no;
							d.bill_category = that.bill_category;
							d.from_date = moment(that.from_date).format('YYYY-MM-DD');
							d.to_date = moment(that.to_date).format('YYYY-MM-DD');
						},
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
					deferRender: true,
					columns: [
						{data: 'id', visible: false},
						{render: function(data,type,full){
							if(full.title != null){
								return full.title;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.categoryName != null){
								return full.categoryName;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.referenceNo != null){
								return full.referenceNo;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.amountBill != null){
								var bill_amount = new Intl.NumberFormat().format(full.amountBill);
								return bill_amount;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.consumerTitle != null){
								return full.consumerTitle;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.transactionCode != null){
								return full.transactionCode;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							var date = full['dueDate'];
							return ''+moment(date).format('MMM D, Y')+'';
						}},
						{render: function(data,type,full){
							var date = full['updated_at'];
							return ''+moment(date).format('MMM D, Y')+'';
						}},
					],
					"order": [[ 0, "desc" ]],
					"initComplete": () => {
						that.hasPer = true;
						that.showBtn = true;
						this.$Progress.finish();
					}
				});
            }
        },
        created() {
			//
        }
    }
</script>
